module.exports = __webpack_public_path__ + "img/t12.2a6c4451.jpeg";